.search {
  position: relative;
  display: flex;
  align-items: center;
  border: 1px solid var(--sbb-color-smoke);
  border-radius: 6px;
  background: var(--sbb-color-white);
  padding: 0 8px;
  gap: 6px;

  &:focus-within {
    border-color: var(--sbb-color-graphite);
  }

  &:hover {
    border-color: var(--sbb-color-graphite);

    svg path {
      stroke: var(--sbb-color-red125);
    }
  }
}

.searchIcon {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  color: var(--sbb-color-graphite);
  pointer-events: none;
}

.input {
  flex: 1 1 auto;
  border: none;
  outline: none;
  background: transparent;
  padding: 5px 0;
  font-size: 14px;
  min-width: 0;
}

.clearIcon {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  cursor: pointer;

  &:hover svg path {
    stroke: var(--sbb-color-red125);
  }
}
